module.exports = "/build/web/svg/sponsor/craft.5a7110f6d905f13f6c0e00e0c84ce500.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/craft.svg
// module id = 207
// module chunks = 24